import React from 'react'
import { useSelector } from 'react-redux'
import Expander from '../Expander'
import Text from '../Text'
import ActionButton from '../ActionButton'
import { getAccessToken } from '../../../reducers/userAccount/selectors/credentials'
import { getPanelUrlForEnv } from '../../../utils/ApiUrl'

export default function(notification, size = 1) {
  const key = useSelector(getAccessToken)

  function action() {
    //var EnvUrl = getApiUrlForEnv()
    window.location.href = `${getPanelUrlForEnv()}/index/login?autologinkey=${key}&redirect=/payment`
  }

  return (
    <Expander size={size} id={notification.id} label={notification.subtitle}>
      <Text size={size}>
        <span dangerouslySetInnerHTML={{ __html: notification.message }} />
        <ActionButton
          size={size}
          label={notification.actionLabel}
          action={action}
        />
      </Text>
    </Expander>
  )
}
